/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const sanitizeChallengesBodySchema = z.object({
  challengeIds: z.array(z.number()).optional(),
  collectionSlug: z.string().optional(),
  batchSize: z.number().min(1).max(500).optional().default(50),
  mode: z.enum(['dry-run', 'execute', 'relink-audio']),
  includePublished: z.boolean().optional().default(false),
  afterId: z.number().optional(),
});

export type ISanitizeChallengesBody = z.input<typeof sanitizeChallengesBodySchema>;
